export { default } from './SearchInput';



// WEBPACK FOOTER //
// ./src/components/Common/Inputs/SearchInput/index.js